document.addEventListener('DOMContentLoaded', function () {
  function getWrappers() {
    return document.querySelectorAll('.variant-option__select-wrapper');
  }

  function applyVisibility() {
    const wrappers = getWrappers();
    if (wrappers.length < 2) return;

    const withChainSelect = wrappers[0].querySelector('select');
    const chainSizeWrapper = wrappers[1];
    const chainSizeLabel = chainSizeWrapper.previousElementSibling; // <label>Chain size</label>

    if (!withChainSelect) return;

    if (withChainSelect.value === 'YES') {
      chainSizeWrapper.style.setProperty('display', '', 'important');
      if (chainSizeLabel) chainSizeLabel.style.setProperty('display', '', 'important');
    } else {
      chainSizeWrapper.style.setProperty('display', 'none', 'important');
      if (chainSizeLabel) chainSizeLabel.style.setProperty('display', 'none', 'important');

      // Auto-select "blank"
      const chainSizeSelect = chainSizeWrapper.querySelector('select');
      if (chainSizeSelect && chainSizeSelect.value !== 'blank') {
        chainSizeSelect.value = 'blank';
        chainSizeSelect.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
  }

  // Re-apply whenever DOM changes
  const observer = new MutationObserver(function () {
    applyVisibility();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['style', 'class']
  });

  document.addEventListener('change', function (e) {
    if (e.target.name === 'options[With chain]') {
      applyVisibility();
    }
  });

  applyVisibility();
});
